// menuItems/pages.js
import {
    AssignmentInd,
    Dashboard,
    Groups3,
    Assessment,
    Subtitles,
    Category,
    AdminPanelSettings,
    Forum,
    EmojiEvents,
    Psychology
} from '@mui/icons-material';

const pages = {
    id: 'pages',
    title: 'Theecastable Admin Panel',
    type: 'group',
    breadcrumbs: false,
    children: [
        {
            id: 'dashboard',
            title: 'Dashboard',
            type: 'item',
            icon: Dashboard,
            url: '/dashboard',
        },
        {
            id: 'role',
            title: 'Role',
            type: 'item',
            icon: AssignmentInd,
            url: '/role',
            perm: 'role',
            action: 'read'
        },
        {
            id: 'user',
            title: 'App Users',
            type: 'item',
            icon: Groups3,
            url: '/user',
            perm: 'user',
            action: 'read'
        },
        {
            id: 'deletedUsers',
            title: 'Deleted Users',
            type: 'item',
            icon: Groups3,
            url: '/deleted-users',
            perm: 'user',
            action: 'read'
        },
        {
            id: 'admin',
            title: 'Admin Users',
            type: 'item',
            icon: AdminPanelSettings,
            url: '/admin',
            perm: 'user',
            action: 'read'
        },
        {
            id: 'promptCategory',
            title: 'Prompt Category',
            type: 'item',
            url: '/promptCategory',
            icon: Category,
            breadcrumbs: false,
            perm: 'prompt',
            action: 'read'
        },
        {
            id: 'leaders',
            title: 'Leaders',
            type: 'item',
            url: '/leaders',
            icon: EmojiEvents,
            breadcrumbs: false,
            perm: 'prompt',
            action: 'read'
        },
        {
            id: 'all',
            title: 'All Prompts',
            type: 'item',
            url: '/prompt',
            icon: Subtitles,
            breadcrumbs: false,
            perm: 'prompt',
            action: 'read'
        },
        {
            id: 'assessmentall',
            title: 'Assessments',
            type: 'item',
            url: '/assessment',
            icon: Assessment,
            breadcrumbs: false,
            perm: 'assessment',
            action: 'read'
        },
        {
            id: 'personalityArchetypes',
            title: 'Personality Archetypes',
            type: 'item',
            url: '/personality-archetypes',
            icon: Psychology,
            breadcrumbs: false,
            perm: 'personalityProfile',
            action: 'read'
        },
        {
            id: 're-assessment-requests-all',
            title: 'Re-Assessment Requests',
            type: 'item',
            url: '/re-assessment-requests',
            icon: Assessment,
            breadcrumbs: false,
            perm: 'assessment',
            action: 'read'
        },
        {
            id: 'feedbacks',
            title: 'Feedbacks',
            type: 'item',
            url: '/feedback',
            icon: Forum,
            breadcrumbs: false,
            perm: 'feedback',
            action: 'read'
        },
        {
            id: 'email',
            title: 'Email',
            type: 'item',
            url: '/email',
            icon: Forum,
            breadcrumbs: false,
            perm: 'email',
            action: 'read'
        },
        {
            id: 'supportTickets',
            title: 'Support Tickets',
            type: 'item',
            url: '/support-tickets',
            icon: Forum,
            breadcrumbs: false,
            perm: 'supportTicket',
            action: 'read'
        }
    ]
};

export default pages;